import React, { Component } from "react";
import { connect } from "react-redux";
import {
  View,
  StyleSheet,
  TouchableHighlight,
  Dimensions,
  Image,
} from "react-native";
import Text from "../components_v2/TextFont";
import PropTypes from "prop-types";
import { TouchableOpacity } from "react-native-gesture-handler";
const SCREEN_HEIGHT = Dimensions.get("screen").height;
const SCREEN_WIDTH = Dimensions.get("screen").width;
const SPINNER_SIZE = 32;
const MAX_REPEAT_ON_FAILURE = 2;

/**@augments{Component<Props,state>} */
class RTSPPlayer extends Component {
  static propTypes = {
    cameraId: PropTypes.number.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    spinnerSize: PropTypes.number,
    maxRepeatOnFailure: PropTypes.number,
    style: PropTypes.shape(),
    onProgress: PropTypes.func,
    onEnd: PropTypes.func,
    onBuffering: PropTypes.func,
    onOpen: PropTypes.func,
    onError: PropTypes.func,
    onPlaying: PropTypes.func,
    onStopped: PropTypes.func,
    onPaused: PropTypes.func,
    onTouch: PropTypes.func,
  };

  constructor(props) {
    super(props);
    let {
      cameraId,
      width,
      height,
      spinnerSize,
      maxRepeatOnFailure,
      style,
    } = this.props;

    if (!cameraId) cameraId = 0;
    if (!width) width = SCREEN_WIDTH;
    if (!height) height = SCREEN_WIDTH * (9 / 16);
    if (!spinnerSize) spinnerSize = SPINNER_SIZE;
    if (!maxRepeatOnFailure) maxRepeatOnFailure = MAX_REPEAT_ON_FAILURE;
    let isPortrait = SCREEN_WIDTH < SCREEN_HEIGHT;

    this._style = style || {};

    this.model = { channels: [] };
    for (var i in this.props.reducer.list) {
      let dvc = this.props.reducer.list[i];
      if (dvc && dvc.cameraId && dvc.cameraId == cameraId) {
        this.model = dvc;
        break;
      }
    }

    this.state = {
      cameraId,
      selectedChannelId: undefined,
      paused: false,
      serverUrl: undefined,
      accessToken: undefined,
      videoSource: undefined,
      width,
      height,
      spinnerSize,
      maxRepeatOnFailure,
      isPortrait,
      logs: "NOT SUPPORTED",
      retryOnFailure: 0,
      showLoading: true,
    };

    this.playerRef = undefined;
  }

  addLog = (message) => {
    if (message) {
      this.setState({ logs: message });
    }
  };

  clearLog = () => {
    if (this.state.logs) {
      this.setState({ logs: undefined });
    }
  };

  render() {
    let { width, height } = this.props;
    if (!width) width = SCREEN_WIDTH;
    if (!height) height = SCREEN_WIDTH * (9 / 16);
    return (
      <View
        style={{
          ...this._style,
          width,
          height: height, //+ 30 // add 30pt to height when using Channels
          borderColor: "#000",
          borderWidth: 1,
        }}
      >
        <TouchableOpacity
          activeOpacity={1}
          onPress={() => {
            this.props.onTouch && this.props.onTouch();
          }}
        >
          <View>
            {this.state.logs && (
              <View style={{ padding: 15 }}>
                <Text style={styles.logs}>{this.state.logs}</Text>
              </View>
            )}

            <View style={{ width, height }}>
              {this.state.showLoading && (
                <Image
                  source={require("../../assets/images/spinner.gif")}
                  width={this.state.spinnerSize}
                  height={this.state.spinnerSize}
                  style={{
                    width: this.state.spinnerSize,
                    height: this.state.spinnerSize,
                    position: "absolute",
                    top: (height - this.state.spinnerSize) / 4, // relative to 16:9 aspect ratio
                    start: (width - this.state.spinnerSize) / 2, // relative to 16:9 aspect ratio
                  }}
                />
              )}
            </View>
          </View>
        </TouchableOpacity>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  logs: {
    color: "#ccc",
    textAlign: "center",
  },
});

const mapStateToProps = (state) => {
  return {
    reducer: state.DeviceReducer,
  };
};

export default connect(mapStateToProps)(RTSPPlayer);
